import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";
import { productAdStatsSchema } from "../../common/statsSchema";

export const productAdApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getV4ProductAds",
    method: "get",
    path: "/v4/query/?table=product_ad&grouping=gvadvertisement_id,gvproduct_id",
    parameters: [
      {
        name: "search",
        type: "Query",
        schema: z.string().array().optional(),
      },
      {
        name: "marketplace",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "start_date",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "end_date",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "start_date_previous",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "end_date_previous",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "filters",
        type: "Query",
        schema: z
          .array(
            z.object({
              id: z.string(),
              value: z.object({
                op: z.string().transform((op) => {
                  return op;
                }),
                value: z.unknown(),
              }),
            }),
          )
          .optional(),
      },
      {
        name: "cursor",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "ordering",
        type: "Query",
        schema: z.string().optional(),
      },
    ],
    status: 200,
    response: z.object({
      data: z.array(
        z
          .object({
            gvproduct_id: z.number(),
            gvadvertisement_id: z.number(),
            product_title: z.string(),
            asin: z.string(),
            sku: z.string(),
            sales_state: z.string(),
            inventory_state: z.string(),
            stock_status: z.string(),
            product_price: z.number(),
            parent_asin: z.string().nullable().optional(),
            user_status: z.string(),
            serving_status: z.string(),
            tags: z.string().transform((tags) => {
              try {
                return JSON.parse(tags) as string[];
              } catch {
                return [];
              }
            }),
          })
          .merge(productAdStatsSchema),
      ),
      cursor: z
        .object({
          hasPreviousPage: z.boolean(),
          hasNextPage: z.boolean(),
          startCursor: z.string().nullable(),
          endCursor: z.string().nullable(),
        })
        .nullable(),
      count: z.number(),
    }),
  }).build(),
);
